module.exports = __webpack_public_path__ + "assets/img/cancel.4baf967a.png";